import { Box } from '@mui/material';
import { PromptsBoxProps } from './promptsBoxTypes';
import { PromptWithArrow } from './PromptWithArrow';
import { useState } from 'react';
import { colors, Typography } from '@sweep-io/sweep-design';

export const PromptsBoxSimple = ({
  predefinedPrompts,
  headerText,
  onConfirm,
  disabled,
}: PromptsBoxProps) => {
  const [sentPromptKeys, setSentPromptKeys] = useState<string[]>([]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        gap: 1,
        pb: 2,
      }}
    >
      {headerText && (
        <Typography color={colors.grey[700]} variant="body-medium">
          {headerText}
        </Typography>
      )}

      {Object.keys(predefinedPrompts).map((key) => {
        const prompt = predefinedPrompts[key];
        return (
          <PromptWithArrow
            key={key}
            prompt={{
              id: key,
              name: prompt,
              promptText: prompt,
            }}
            isDisabled={disabled}
            onClick={() => {
              onConfirm(prompt);
              setSentPromptKeys([...sentPromptKeys, key]);
            }}
          />
        );
      })}
    </Box>
  );
};
